import axios from 'axios'

const RESOURCE_NAME = '/users'

export default {

  delete (id, mediaId) {
    return axios.delete(`${RESOURCE_NAME}/${id}/delete-media/${mediaId}`)
  },
  get (id) {
    return axios.get(`${RESOURCE_NAME}/${id}`)
  },
  updateAlerts (data) {
    return axios.post(`/update-alerts`, data)
  },
  changePassword (data) {
    return axios.post(`/change-password`, data)
  },
  getPoints (id) {
    return axios.get(`${RESOURCE_NAME}/get-points/${id}`)
  },
  getOfferData (id) {
    return axios.get(`${RESOURCE_NAME}/get-partner-offer-data/${id}`)
  },
  resetPassword (data) {
    return axios.post(`/reset-password`, data)
  }
}
